import { FC, useMemo, useState } from "react";
import { PinInput } from "react-input-pin-code";
import cn from "classnames";
import { Button } from "antd";
import {
  confirmEmail,
  confirmSignup,
} from "../../../store/actions/registrationAction";
import { useAppDispatch, useAppSelector } from "../../../store";
import {
  PinContainerStyle,
  PinInputStyle,
  greenRgbColor,
  pastelBlue,
  brightRed,
} from "../../../utils";
import { SendToEnum } from "../../../types/types";
import { tabsNamesKeys } from "../Registration.models";
import Counter from "./Counter";
import styles from "./styles.module.css";
import { ArrowLeftOutlined } from "@ant-design/icons";

interface IConfirmCodeProps {
  setStep: (step: tabsNamesKeys) => void;
}

const SENDED_TO_TEXTS: Record<SendToEnum, (value: string) => JSX.Element> = {
  [SendToEnum.phone]: (value: string) => (
    <p>
      SMS-код отправлен на номер <br />
      <span>{value}</span>
      <br /> Введите полученный код ниже
    </p>
  ),
  [SendToEnum.email]: (value: string) => (
    <p>
      Код подтверждения отправлен на <br />
      <span>{value}</span>
      <br /> Введите полученный код ниже
    </p>
  ),
};

const BACK_BUTTON_TEXTS = {
  [SendToEnum.phone]: "Вернуться к вводу номера телефона",
  [SendToEnum.email]: "Вернуться к вводу email",
};

const ConfirmCode: FC<IConfirmCodeProps> = ({ setStep }) => {
  const dispatch = useAppDispatch();
  const { sended_to, sended_to_value, _isLoading, _isForeignPhone } =
    useAppSelector(({ registrationSlice }) => registrationSlice);

  const [values, setValues] = useState(new Array(6).fill(""));

  const onBackHandler = () => {
    if (sended_to === SendToEnum.phone) {
      setStep(tabsNamesKeys.phone);
      return;
    }

    setStep(tabsNamesKeys.email);
  };

  const onConfirmCode = () => {
    const code = values.join("").trim();
    if (code.length !== 6) {
      return;
    }

    if (sended_to === SendToEnum.phone) {
      dispatch(confirmSignup({ code, setStep }));
      return;
    }

    if (sended_to === SendToEnum.email && _isForeignPhone) {
      dispatch(confirmSignup({ code, setStep }));
      return;
    }

    dispatch(confirmEmail({ code, setStep }));
  };

  const isSubmittable = useMemo(
    () => values.join("").trim().length === 6,
    [values]
  );

  return (
    <div className={styles._container}>
      <div className={styles._body}>
        {sended_to && (
          <p className={styles.send_to}>
            {SENDED_TO_TEXTS[sended_to](sended_to_value ?? "")}
          </p>
        )}

        <PinInput
          containerStyle={PinContainerStyle}
          inputStyle={PinInputStyle}
          autoFocus={true}
          placeholder={""}
          values={values}
          onChange={(_, __, values) => setValues(values)}
          validBorderColor={greenRgbColor}
          focusBorderColor={pastelBlue}
          errorBorderColor={brightRed}
        />

        <Counter setStep={setStep} />

        <Button
          type="primary"
          disabled={!isSubmittable || _isLoading}
          className={cn(styles.nextButton, styles.confirmCodeBtn)}
          onClick={onConfirmCode}
        >
          Подтвердить
        </Button>
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          className={styles.backButton}
          onClick={onBackHandler}
        >
          {BACK_BUTTON_TEXTS[sended_to ?? SendToEnum.phone]}
        </Button>
      </div>
    </div>
  );
};

export default ConfirmCode;
